module.exports = __webpack_public_path__ + "img/booster.75281bbe.jpg";